import React from 'react';

import ConfirmDialog from '../ConfirmDialog';

const ConfirmVersionDialog = ({ isOpen, onClose, onSubmit }) => {
  return (
    <ConfirmDialog
      title="Confirmar alteração"
      body="Você tem certeza que quer alterar para outra versão do Bot? Todas as edições realizadas serão perdidas"
      show={isOpen}
      handleClose={onClose}
      onConfirm={onSubmit}
    >
      Você tem certeza que deseja publicar?
    </ConfirmDialog>
  );
};

export default ConfirmVersionDialog;
